import { Grid } from '@mui/material';
import { WsTypography, WsTypoVariants } from 'wisestep-base';

import CountWithTextCard from '../../../../analytics/components/countWithTextCard';
import usePostgreRTRAnalyticsWidgetData from '../hooks/usePostgreRTRAnalyticsWidgetData';
import { IPostgreRTRWidgetProp } from '../types';

const RTRSplitMetricPostgres = ({ query, title }: IPostgreRTRWidgetProp) => {
  const { widgetData } = usePostgreRTRAnalyticsWidgetData(query);

  return (
    <Grid container p={2}>
      <Grid item xs={12} mb={2}>
        <WsTypography variant={WsTypoVariants.TITLE} bold={true}>
          {title}
        </WsTypography>
      </Grid>
      <Grid item xs={2} ml={10}>
        <CountWithTextCard variant="h4" count={widgetData.count ?? 0} fullHeight text={'Total'} />
      </Grid>
      {widgetData.resultSet?.map((result) => (
        <Grid key={result.status} item xs={1} ml={10}>
          <CountWithTextCard
            variant="h4"
            count={result.count ?? 0}
            fullHeight
            text={result.status ?? ''}
            textVariant="caption"
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default RTRSplitMetricPostgres;
